import { FC, FocusEvent, useState } from "react";

import { useFormikContext } from "formik";

import TextInput from "@components/TextInput";
import { withCompositeFormikField } from "@lib/withFormikField";

import TimeSelect from "./TimeSelect";
import type { TTimeOption, TTimePickerProps } from "./types";

const TimePicker: FC<TTimePickerProps> = ({
  id,
  value,
  options,
  isDisabled,
  onChange,
  onFocus,
  setFieldValue,
  noOptionsMessage,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { setFieldTouched } = useFormikContext();

  const handleOptionSelected = (option: TTimeOption) => {
    onChange?.(option?.time);
    setFieldValue?.(option?.time);
  };

  const handleInputFocus = (evt: FocusEvent<HTMLInputElement>) => {
    setIsOpen(true);
    onFocus?.(evt);
  };

  // Because input is read only we have to disable on blur to avoid validation
  // after focus
  const handleInputBlur = () => {};

  const handleOnClose = () => {
    if (rest.name) {
      setFieldTouched(rest.name, true);
    }
  };

  const timeSelect = (
    <TimeSelect
      id={id}
      isOpen={isOpen}
      onToggleOpen={setIsOpen}
      isDisabled={isDisabled}
      options={options}
      onSelect={handleOptionSelected}
      selectedTime={value}
      noOptionsMessage={noOptionsMessage}
      onClose={handleOnClose}
    />
  );

  return (
    <TextInput
      id={id}
      {...rest}
      isReadOnly
      value={value || ""}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
      isDisabled={isDisabled}
      isFormik={false}
      rightAddon={timeSelect}
      rightSpacing="1px"
      rightAddonOffset="2.75rem"
    />
  );
};

export default withCompositeFormikField({ hasSetFieldValue: true })(TimePicker);
